import {Fragment} from "react";

import {Button, Col, Container, Nav, Row} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import PreviousDataEntry from "./PreviousDataEntry";
import TestPage from "./TestPage";


export default function Setting(){

    return(
        <Fragment>
            <div className="purchaseDiv text-center">
                <Nav className="navItem float-end"><NavLink to="/home"><Button variant="warning" >Close</Button></NavLink></Nav>
                <h3>All Setting</h3>
                <hr/>
                <Tabs
                    defaultActiveKey="home"
                    transition={false}
                    id="noanim-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="home" title="Home"></Tab>

                    <Tab eventKey="NewBin" title="New BIN"></Tab>
                    <Tab eventKey="Revenue" title="Previous Revenue entry"><PreviousDataEntry/></Tab>
                    <Tab eventKey="test" title="Test Page"><TestPage/></Tab>

                </Tabs>
            </div>
        </Fragment>
    )
}